export { PrivacyPolicy } from "./PrivacyPolicy"
